(() => {
  const init = () => {
    const popup = document.querySelector('[data-referral-popup]');
    if (!popup || popup.dataset.proxyRecoveryReady === 'true') return;
    popup.dataset.proxyRecoveryReady = 'true';

    const codeEl = popup.querySelector('[data-welcome-code-value]');
    const codeButton = popup.querySelector('[data-copy-welcome-code]');
    const status = popup.querySelector('[data-welcome-status]');
    const successView = popup.querySelector('[data-referral-success-view]');
    if (!codeEl || !codeButton || !status || !successView) return;

    let retryButton = popup.querySelector('[data-referral-retry]');
    if (retryButton) {
      const cleanButton = retryButton.cloneNode(true);
      retryButton.replaceWith(cleanButton);
      retryButton = cleanButton;
    } else {
      retryButton = document.createElement('button');
      retryButton.type = 'button';
      retryButton.dataset.referralRetry = '';
      retryButton.textContent = 'Försök igen';
      retryButton.style.cssText = 'display:none;margin-top:10px;border:0;border-radius:10px;padding:10px 14px;background:#23211e;color:#fff;font:inherit;font-weight:700;cursor:pointer';
      codeButton.insertAdjacentElement('afterend', retryButton);
    }

    const ownCode = () => {
      try {
        return (localStorage.getItem('ellivieReferralCode') || '').trim().toUpperCase();
      } catch (_) {
        return '';
      }
    };

    const loading = () => {
      codeButton.disabled = true;
      delete codeButton.dataset.code;
      codeEl.textContent = 'Skapar kod…';
      status.textContent = 'Vi aktiverar din personliga rabattkod hos Shopify…';
      retryButton.style.display = 'none';
    };

    const failed = (message) => {
      codeButton.disabled = true;
      delete codeButton.dataset.code;
      codeEl.textContent = 'Koden är inte klar än';
      status.textContent = message || 'Rabattkoden kunde inte aktiveras just nu.';
      retryButton.style.display = 'inline-block';
    };

    const ready = (code) => {
      codeEl.textContent = code;
      codeButton.disabled = false;
      codeButton.dataset.code = code;
      status.textContent = 'Din personliga kod är aktiverad och kan användas en gång.';
      retryButton.style.display = 'none';
    };

    const parseResponse = async (response) => {
      const text = await response.text();
      let data = null;
      try { data = JSON.parse(text); } catch (_) {}
      return { response, data };
    };

    const requestStatus = async (code) => {
      const suffix = `code=${encodeURIComponent(code)}&_=${Date.now()}`;

      try {
        const proxyResult = await parseResponse(await fetch(`/apps/ellivie-referral?${suffix}`, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin'
        }));

        if (proxyResult.response.ok && proxyResult.data) return proxyResult.data;
        if (proxyResult.response.status !== 404) {
          throw new Error(proxyResult.data?.welcomeError || `Kodtjänsten svarade med HTTP ${proxyResult.response.status}`);
        }
      } catch (error) {
        if (error?.message && !/HTTP 404/.test(error.message)) {
          // A network/proxy failure can still be recovered through the public API below.
        }
      }

      const directResult = await parseResponse(await fetch(`https://studio.elliviehome.com/api/referral-status?${suffix}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        mode: 'cors'
      }));

      if (!directResult.response.ok) {
        throw new Error(directResult.data?.welcomeError || `Kodtjänsten svarade med HTTP ${directResult.response.status}`);
      }
      if (!directResult.data) throw new Error('Kodtjänsten gav ett oväntat svar.');
      return directResult.data;
    };

    const check = async () => {
      const code = ownCode();
      if (!code) {
        failed('Vi hittar inte din registreringskod i webbläsaren. Registrera dig igen eller kontakta oss så hjälper vi dig.');
        return;
      }

      loading();
      try {
        const data = await requestStatus(code);
        if (data.welcomeReady && data.welcomeCode) {
          ready(data.welcomeCode);
          return;
        }
        failed(data.welcomeError || 'Registreringen är klar, men rabattkoden är ännu inte färdig. Försök igen om en liten stund.');
      } catch (error) {
        failed(error?.message === 'Failed to fetch'
          ? 'Kodtjänsten går inte att nå från butiken just nu. Kontrollera App Proxy-inställningen i Shopify och försök igen.'
          : (error?.message || 'Vi kunde inte nå kodtjänsten just nu.'));
      }
    };

    retryButton.addEventListener('click', check);

    const watch = new MutationObserver(() => {
      if (!successView.hasAttribute('hidden') && !codeButton.dataset.code) {
        window.setTimeout(check, 250);
      }
    });
    watch.observe(successView, { attributes: true, attributeFilter: ['hidden'] });

    if (!successView.hasAttribute('hidden') && !codeButton.dataset.code) {
      window.setTimeout(check, 250);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
